import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { DuplicateNriCalculationsResponse } from './types';

export const [
  duplicateNriCalculationsAtom,
  duplicateNriCalculationsLoadableAtom,
] = atomWithLoadable(async () => {
  const response = await request.get<DuplicateNriCalculationsResponse>(
    '/admin/duplicate_nri_calculations'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});
